<div
  class="row"
  (click)="handleInquiryClick(inquiry)"
>
  <div
    baseTruncate
    class="col-2 listview-highlight-text d-flex flex-column"
  >
    <span
      class="listview-highlight-text"
      baseTruncate
    >
      {{ inquiry.customerDepartment?.name | baseIsEmpty }}
    </span>
    <span baseTruncate>{{ inquiry.customerLocation?.name | baseIsEmpty }}</span>
  </div>
  <div
    baseTruncate
    class="col-2"
  >
    <span class="text-dark-green">{{ inquiry.mainQualification?.name | baseIsEmpty }}</span>
    <ng-container *ngIf="inquiry.qualifications?.length">
      <br />
      <span class="text-dark-gray"
        >{{ inquiry.qualifications[0].name | baseIsEmpty }}<br />
        <ng-container *ngIf="inquiry.qualifications.length > 1">
          + {{ inquiry.qualifications.length - 1 }} {{ 'additional' | translate }}
        </ng-container>
      </span>
    </ng-container>
  </div>
  <div
    baseTruncate
    class="col-1"
  >
    <ng-container *ngIf="inquiry.createdAt"> {{ inquiry.createdAt | baseFormatDate }}<br /> </ng-container>
    {{ inquiry.createdBy?.firstName | baseIsEmpty }} {{ inquiry.createdBy?.lastName | baseIsEmpty }}
  </div>
  <div
    baseTruncate
    class="col-2"
  >
    {{ inquiry.dateFrom | baseFormatDate | baseIsEmpty }} -<br />
    <ng-container *ngIf="!inquiry.unlimited; else unlimitedDate">
      {{ inquiry.dateTo | baseFormatDate | baseIsEmpty }}
    </ng-container>
    <ng-template #unlimitedDate>
      {{ inquiry.dateTo | baseFormatDate | baseIsEmpty }} ({{ 'inquiry.unlimitedUntilMLPShort' | translate }})
    </ng-template>
  </div>
  <div class="col-1">
    <div class="circle-md bg-dark">{{ inquiry.assignmentCount?.all | baseIsEmpty }}</div>
  </div>
  <div class="col-4">
    <div class="row">
      <div class="col-4 d-flex justify-content-center">
        <base-offers-status
          [state]="baseInquiryStatus.published"
          [confirmedOffers]="inquiry.offersCount?.confirmed"
          [declinedOffers]="inquiry.offersCount?.declined"
          [openOffers]="inquiry.offersCount?.open"
          [needConfirmationOffers]="inquiry.offersCount?.needsConfirmation"
          [areDeclinedOffersAvailable]="canPreselectOffers"
        ></base-offers-status>
      </div>
      <div class="col-6">
        <span
          baseTruncate
          *ngIf="inquiry.status === baseInquiryStatus.closed || !canPublishInquiry"
          [ngbTooltip]="
            inquiry?.closedNote ? inquiry.closedNote : ('inquiry.closeInquiry.closedWithoutReason' | translate)
          "
          class="fw-bold"
          [ngClass]="{
            'inquiry-closed-state': inquiry.status === baseInquiryStatus.closed,
            'text-success': inquiry.status === baseInquiryStatus.published,
            'text-danger': inquiry.status === baseInquiryStatus.unpublished
          }"
        >
          {{ 'states.' + baseInquiryStatus[inquiry.status] | translate | uppercase }}
        </span>
        <base-action-dropdown
          *ngIf="inquiry.status !== baseInquiryStatus.closed && canPublishInquiry"
          class="mw-100"
          [items]="
            inquiry.status === baseInquiryStatus.unpublished
              ? ['action.close', 'action.publish', 'action.edit']
              : ['action.close']
          "
          [label]="'states.' + baseInquiryStatus[inquiry.status]"
          [color]="inquiry.status === baseInquiryStatus.unpublished ? 'outline-danger' : 'outline-success'"
          (listItemClicked)="handleClick($event, inquiry.id)"
          (click)="$event.stopPropagation()"
        ></base-action-dropdown>
      </div>
      <div class="col-2 d-flex justify-content-end">
        <base-button
          class="ps-1"
          [ngbTooltip]="'inquiry.createByCopy' | translate"
          color="dark"
          icon="fa-solid fa-copy"
          [iconSize]="buttonSizes.md"
          stateClass="pe-1"
          (btnClick)="copyInquiryHandler($event, inquiry)"
        ></base-button>
      </div>
    </div>
  </div>
</div>

<ng-template #staffRequest>
  <base-customer-staff-request-modal
    [modalRef]="newStaffRequestModalRef"
    [inquiry]="copiedInquiry"
    [selectedFilters]="filters"
  ></base-customer-staff-request-modal>
</ng-template>

<ng-template #closeInquiryModal>
  <base-customer-close-inquiry-form [modalRef]="onInquiryCloseModalRef"></base-customer-close-inquiry-form>
</ng-template>
